import { createContext, use } from 'react'

/**
 * A slot among the Add tiles of a saved course's Activities section, handed the course's id as
 * `recordId`, where other areas add their own way of adding activities, such as Launch's Add from
 * Tool (LCH-18). A contribution renders `ActivityAddTile`, so it looks like the tiles beside it.
 */
export const activityAddSlot = 'catalog.activity-editor.add'

/** What a contribution to the Add slot may ask of the course form. */
export interface ActivityAdding {
  /**
   * Loads the course and its activities again, as after someone else changed them, for a
   * contribution that added activities through its own endpoint; `null` where the form cannot.
   */
  readonly reload: (() => void) | null
}

export const ActivityAddingContext = createContext<ActivityAdding>({ reload: null })

/** What the surrounding course form lets an Add slot contribution do. */
export function useActivityAdding(): ActivityAdding {
  return use(ActivityAddingContext)
}
